var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, compose, graphql, Separator, Spinner, TextAlignCenterDiv, useMutation } from "@atlassiansox/microscopekit";
import platform from "../../images/platform.png";
import serviceSuccess from "../../images/service_success.png";
import { TaskExecutionMode, WargameTemplatePublishStatus } from "../../../__generated__/graphql-global-types";
import { ButtonGroup } from "@atlaskit/button";
import SectionMessage from "@atlaskit/section-message";
import { useQueryParams } from "../../hooks";
import { CreateExerciseTemplateMappingMutation, CreateTemplateMutation, WargameExerciseMasterDataQuery } from "../../graphql";
import { isResourceAzFailoverFault } from "./TaskGroups/Faults/useAzFailover";
import { useAnalytics, useSendScreenEvent } from "../../analytics";
export var getFaultParameters = function (faultExecution, faultParameters) {
    var _a;
    var formattedFaultParamaters = __assign({}, faultParameters);
    if (isResourceAzFailoverFault(faultExecution)) {
        var formattedResources = (_a = faultParameters === null || faultParameters === void 0 ? void 0 : faultParameters.resource_name) === null || _a === void 0 ? void 0 : _a.split(":").map(function (e) { return e.trim(); });
        formattedFaultParamaters.resource_type = formattedResources === null || formattedResources === void 0 ? void 0 : formattedResources[0];
        formattedFaultParamaters.resource_name = formattedResources === null || formattedResources === void 0 ? void 0 : formattedResources[1];
    }
    return formattedFaultParamaters;
};
var PublishTemplateForm = function (props) {
    var _a = __read(useState(false), 2), isTemplateSaving = _a[0], setIsTemplateSaving = _a[1];
    var _b = __read(useState(false), 2), isTemplateSaved = _b[0], setIsTemplateSaved = _b[1];
    var history = useHistory();
    var wargameExerciseId = useQueryParams().get("wargameExerciseId");
    var _c = __read(useMutation(CreateExerciseTemplateMappingMutation, {
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: WargameExerciseMasterDataQuery,
                variables: { id: wargameExerciseId }
            }
        ]
    }), 1), createWargameExerciseTemplateMapping = _c[0];
    var _d = useAnalytics(), sendUIEvent = _d.sendUIEvent, sendTrackEvent = _d.sendTrackEvent;
    useSendScreenEvent("createWargamePlanPublishStep");
    var _e = __read(useState(""), 2), errorMessage = _e[0], setErrorMessage = _e[1];
    var publishWargame = function (event) {
        saveWargameTemplate(WargameTemplatePublishStatus.published);
    };
    var saveWargameAsDraft = function (event) {
        console.log("in saveWargameAsDraft");
        saveWargameTemplate(WargameTemplatePublishStatus.draft);
    };
    var saveWargameTemplate = function (status) {
        sendUIEvent({
            source: "createWargamePlanPublishStep",
            actionSubject: "button",
            action: "clicked",
            actionSubjectId: "publishTemplate",
            attributes: {
                wargameTemplate: props.wargameTemplate
            }
        });
        var wargameTemplate = props.wargameTemplate;
        setIsTemplateSaving(true);
        props
            .createTemplateData({
            variables: {
                wargameTemplate: {
                    name: wargameTemplate.name,
                    description: "",
                    environment: wargameTemplate.environment,
                    version: "1.0",
                    wargameParent: "",
                    service: props.serviceId,
                    premise: wargameTemplate.premise != null
                        ? wargameTemplate.premise.length > 0
                            ? [
                                {
                                    name: "",
                                    description: "",
                                    provider: wargameTemplate.premise[0].provider,
                                    inputType: wargameTemplate.premise[0].inputType,
                                    inputData: {
                                        request_data: wargameTemplate.premise[0].inputData.request_data,
                                        apis: wargameTemplate.premise[0].inputData.apis,
                                        repo: wargameTemplate.premise[0].inputData.repo,
                                        branch: wargameTemplate.premise[0].inputData.branch,
                                        script_name: wargameTemplate.premise[0].inputData.script_name,
                                        user_count: wargameTemplate.premise[0].inputData.user_count,
                                        ramp_up_time: wargameTemplate.premise[0].inputData.ramp_up_time,
                                        steady_state_time: wargameTemplate.premise[0].inputData
                                            .steady_state_time,
                                        queue_url: wargameTemplate.premise[0].inputData.queue_url,
                                        request_method: wargameTemplate.premise[0].inputData
                                            .request_method,
                                        custom_env_variables: wargameTemplate.premise[0].inputData
                                            .custom_env_variables
                                    }
                                }
                            ]
                            : null
                        : null,
                    taskGroup: wargameTemplate.taskGroup !== undefined
                        ? wargameTemplate.taskGroup.map(function (taskGroup) { return ({
                            name: "",
                            executionMode: TaskExecutionMode.sequential,
                            delayBeforeExecution: taskGroup.delayBeforeExecution,
                            steadyStates: taskGroup.steadyStates.map(function (steadyState) { return ({
                                probeAction: steadyState.probeAction,
                                probeCategory: steadyState.probeCategory,
                                parameters: steadyState.parameters
                            }); }),
                            faults: taskGroup.faults.map(function (faultInput) { return ({
                                faultCategory: faultInput.faultCategory,
                                faultAction: faultInput.faultExecution,
                                delayBeforeExecution: faultInput.delayBeforeExecution,
                                faultParameters: getFaultParameters(faultInput.faultExecution, faultInput.parameters)
                            }); })
                        }); })
                        : [],
                    publishStatus: status
                }
            }
        })
            .then(function (response) {
            var _a;
            var wargameTemplateId = (_a = response.data) === null || _a === void 0 ? void 0 : _a.createWarGameTemplate.id.toString();
            return wargameExerciseId
                ? createWargameExerciseTemplateMapping({
                    variables: {
                        templateID: wargameTemplateId,
                        exerciseID: wargameExerciseId
                    }
                }).then(function () { return "./exercise/" + wargameExerciseId; })
                : "./template-details?id=" + wargameTemplateId;
        })
            .then(function (redirectUrl) {
            setIsTemplateSaving(false);
            setIsTemplateSaved(true);
            history.push(redirectUrl);
            sendTrackEvent({
                action: "published",
                actionSubject: "wargamePlan",
                actionSubjectId: props.wargameTemplate.id,
                source: "createWargamePlanPublishStep"
            });
        })
            .catch(function (apolloError) {
            setIsTemplateSaving(false);
            setErrorMessage(apolloError.message);
            sendTrackEvent({
                action: "publishFailed",
                actionSubject: "wargamePlan",
                actionSubjectId: props.wargameTemplate.id,
                source: "createWargamePlanPublishStep",
                attributes: {
                    error: apolloError.message
                }
            });
        });
    };
    return (React.createElement("div", null,
        React.createElement(TextAlignCenterDiv, null,
            React.createElement("img", { src: platform, alt: "Platform", height: 256, hidden: isTemplateSaved }),
            React.createElement("img", { src: serviceSuccess, alt: "Service Success", height: 256, hidden: !isTemplateSaved }),
            React.createElement("div", { hidden: !isTemplateSaving },
                React.createElement(Spinner, null))),
        React.createElement(Separator, null),
        React.createElement("div", { hidden: errorMessage.length === 0 },
            React.createElement(SectionMessage, { appearance: "error" }, errorMessage)),
        React.createElement("div", { hidden: isTemplateSaving || isTemplateSaved },
            React.createElement(TextAlignCenterDiv, null,
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { appearance: "default", onClick: saveWargameAsDraft }, "Save to Draft"),
                    React.createElement(Button, { appearance: "primary", onClick: publishWargame }, "Publish")))),
        React.createElement("div", { hidden: !isTemplateSaved },
            React.createElement(TextAlignCenterDiv, null, "Redirecting to plan page..."))));
};
export var PublishStatusFormFc = compose(graphql(CreateTemplateMutation, {
    name: "createTemplateData",
    options: function (props) { return ({
        query: CreateTemplateMutation,
        variables: { wargameTemplate: props.wargameTemplateInput }
    }); }
}))(PublishTemplateForm);
